import { render, staticRenderFns } from "./PlotRecommenderProviderFilter.vue?vue&type=template&id=d4c012f0&scoped=true"
import script from "./PlotRecommenderProviderFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlotRecommenderProviderFilter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PlotRecommenderProviderFilter.vue?vue&type=style&index=0&id=d4c012f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c012f0",
  null
  
)

export default component.exports